import { render, staticRenderFns } from "./BtnLoading.vue?vue&type=template&id=6470bce0&scoped=true"
import script from "./BtnLoading.vue?vue&type=script&lang=js"
export * from "./BtnLoading.vue?vue&type=script&lang=js"
import style0 from "./BtnLoading.vue?vue&type=style&index=0&id=6470bce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6470bce0",
  null
  
)

export default component.exports